import { ONE_HUNDRED_PERCENT } from '../../constants';
import { EditorialVideoFragment, PumoModuleSlideFragment } from '../../generated/types';

const DEFAULT_SLIDE_WIDTH_TO_HEIGHT = 1;
const DEFAULT_VIDEO_WIDTH_TO_HEIGHT = 3;

export const getVideoAndSlideWidth = ({
  video,
  slide
}: {
  video: EditorialVideoFragment;
  slide: PumoModuleSlideFragment;
}) => ({
  slide: slide.featureImage?.paddingBottom
    ? (1 / slide.featureImage.paddingBottom) * ONE_HUNDRED_PERCENT
    : DEFAULT_SLIDE_WIDTH_TO_HEIGHT,
  video: video.width && video.height ? video.width / video.height : DEFAULT_VIDEO_WIDTH_TO_HEIGHT
});
